var IframeMessageReceiver = /** @class */ (function () {
    function IframeMessageReceiver(expectedOrigin, receivers) {
        this.expectedOrigin = expectedOrigin;
        this.receivers = receivers;
        this.messageEventListener = this.messageEventListener.bind(this);
        window.addEventListener('message', this.messageEventListener, false);
    }
    IframeMessageReceiver.create = function (expectedOrigin, receivers) {
        return new IframeMessageReceiver(expectedOrigin, receivers);
    };
    IframeMessageReceiver.prototype.dispose = function () {
        window.removeEventListener('message', this.messageEventListener);
    };
    IframeMessageReceiver.prototype.messageEventListener = function (event) {
        if (process.env.NODE_ENV !== 'development' && event.origin !== this.expectedOrigin) {
            return;
        }
        if (event.data.type in this.receivers) {
            this.receivers[event.data.type](event.data);
        }
    };
    return IframeMessageReceiver;
}());
export { IframeMessageReceiver };
